import { SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { DevicesManagerService } from '../../../services/devices-manager.service';
import { PermissionService } from '../../../services/permission.service';
import { DEVICES_PRIVATE } from '../../devices/devices-routing.constants';
import { DeviceCardComponent } from '../../shared/card/device-card/device-card.component';
import { WidgetLoaderComponent } from '../../shared/widget/widget-loader/widget-loader.component';

@Component({
  selector: 'widget-private',
  templateUrl: './widget-private.component.html',
  styleUrls: ['./widget-private.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DeviceCardComponent, WidgetLoaderComponent, MatTooltipModule, MatIcon, TranslatePipe, SlicePipe],
})
export class WidgetPrivateComponent {
  private _router = inject(Router);
  public permissionService = inject(PermissionService);
  public DEVICES_PRIVATE = DEVICES_PRIVATE;
  private _devicesManagerService = inject(DevicesManagerService);
  public $privateDevices = this._devicesManagerService.$privateDevices;
  public $devicesMap = this._devicesManagerService.$devicesMap;

  goTo(link: (string | number)[]) {
    this._router.navigate(link);
  }
}
